import { Alert, Typography } from '@vivaldis/antd-ui'
import { useTranslation } from 'react-i18next'
import { IdCardImages } from './components/IdCardImages'

export const FormContent = () => {
  const [t] = useTranslation('web_ui')
  return (
    <>
      <Typography.Title level={5} marginBottom={16}>
        {t(
          'edit_employee_personal_information_form.steps.upload_id_document.section_header'
        )}
      </Typography.Title>
      <Alert
        title={t(
          'edit_employee_personal_information_form.steps.upload_id_document.alert.title'
        )}
        type="warning"
        style={{
          marginBottom: 16
        }}
      />
      <IdCardImages />
    </>
  )
}
